import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";
import { baseURL } from "../../services/axios/eps";

const BugDetailsModal = ({
  showDetailsModal,
  setShowDetailsModal,
  selectedData,
  setSelectedData,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedData({});
    setShowDetailsModal(false);
  };

  return (
    <Modal
      show={showDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Bug Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <div className="d-flex justify-content-center">
          {selectedData?.screenshot && (
            <img
              crossorigin="anonymous"
              src={`${baseURL}/uploads/file/${selectedData.screenshot}`}
              alt="Logo"
              className="img-fluid rounded center"
              style={{ maxWidth: "80%", objectFit: "contain" }}
            />
          )}
        </div>
        <Row className="mb-3">
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">Bug</span>
              <span className="d-block fs-5 fw-medium text-light">
                {selectedData.message || ""}
              </span>
            </div>
          </Col>
          {Object.entries({
            Game: selectedData?.related_game?.title || "",
            "Reported By": selectedData?.reported_by?.email || "",
            Resolved: selectedData.resolved ? "Yes" : "No",
            Date: selectedData?.createdAt
              ? format(selectedData?.createdAt, "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value ? "text-danger" : "text-light"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default BugDetailsModal;
